// Feature flags per controllare funzionalità dell'applicazione
export const FEATURE_FLAGS = {
  // SearchPage flags
  SHOW_FILTERS: false,           // Nasconde i filtri nella pagina di ricerca
  SHOW_REGIONS: true,            // Mostra il box delle regioni
    // Header flags
  SHOW_LOGIN_REGISTER: true,     // Mostra i link "Accedi" e "Registrati"
  SHOW_POST_AD: false,            // Mostra il pulsante "Carica Annuncio"
  
  // Footer flags
  SHOW_DEAD_LINKS: false,        // Nasconde i link morti nel footer
  
  // DetailPage flags
  SHOW_CONTACT_TAB: false,       // Nasconde il tab "Contact" nel profilo escort
  SHOW_AVAILABILITY: false,      // Nasconde la sezione "Availability"
    // Development flags
  DEV_MODE: import.meta.env.DEV, // Modalità sviluppo
  LOG: true,
  
  // FG (Fingerprinting) flags
  FG_ENABLED: true,              // Abilita la raccolta dati fg
  FG_SEND_DATA: false,           // Disabilita l'invio dei dati al server (solo raccolta locale)
  FG_COUNTRY_FILTER: true,       // Abilita il filtro per paese
  FG_CACHE: true,                // Abilita la cache dei dati fg
  FG_DEBUG: import.meta.env.DEV, // Mostra componente debug fg
};

export default FEATURE_FLAGS;
